import { Callout } from "../components/Callout.js";
import { ScreenshotBox } from "../components/ScreenshotBox.js";

export const meta = {
  title: "プロパティの一括作成",
  updatedAt: "2026-07-13",
};

export function Content() {
  return (
    <>
      <p>
        Sign Extension が利用する HubSpot プロパティ 16 項目を、1 クリックで一括作成できます。
        手動で作るより早く、命名規則も統一されます。
      </p>

      <h2>作成される 16 項目</h2>
      <p>
        「接続設定」タブの「プロパティの一括作成」で対象オブジェクト（取引・会社・コンタクト）を
        開き、画面上部の「<strong>◯◯に全プロパティを一括作成</strong>」ボタンを押すと、
        以下 16 項目が HubSpot に作成されます。
      </p>
      <ScreenshotBox src="/guide/screenshots/bulk-properties-1.png" caption="一括作成ボタンの位置" />

      <h3>基本マッピング（4 項目）</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0", fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={th()}>ラベル</th>
            <th style={th()}>内部名</th>
            <th style={th()}>タイプ</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={td()}>クラウドサインステータス</td><td style={code()}>cs_status</td><td style={td()}>選択式</td></tr>
          <tr><td style={td()}>クラウドサイン書類 ID</td><td style={code()}>cs_document_id</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>下書き URL</td><td style={code()}>cs_draft_url</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>締結完了 URL</td><td style={code()}>cs_completed_url</td><td style={td()}>1 行テキスト</td></tr>
        </tbody>
      </table>
      <p style={{ fontSize: 13, color: "#6b6b68" }}>
        クラウドサインステータスは以下 6 種類の選択肢が付きます：
        <strong>下書き / 送信済み / 顧客署名済 / 締結完了 / 却下 / 期限切れ</strong>
      </p>

      <h3>ファイル系（4 項目）</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0", fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={th()}>ラベル</th>
            <th style={th()}>内部名</th>
            <th style={th()}>タイプ</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={td()}>契約書</td><td style={code()}>contract_file</td><td style={td()}>ファイル</td></tr>
          <tr><td style={td()}>別紙・付属書類</td><td style={code()}>appendix_file</td><td style={td()}>ファイル</td></tr>
          <tr><td style={td()}>締結完了ファイル</td><td style={code()}>cs_completed_file</td><td style={td()}>ファイル</td></tr>
          <tr><td style={td()}>合意締結証明書</td><td style={code()}>cs_agreement_file</td><td style={td()}>ファイル</td></tr>
        </tbody>
      </table>

      <h3>送付先（署名者）情報（4 項目）</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0", fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={th()}>ラベル</th>
            <th style={th()}>内部名</th>
            <th style={th()}>タイプ</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={td()}>送付先氏名 1</td><td style={code()}>cs_recipient_name</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>送付先メール 1</td><td style={code()}>cs_recipient_email</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>送付先氏名 2</td><td style={code()}>cs_recipient_name_2</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>送付先メール 2</td><td style={code()}>cs_recipient_email_2</td><td style={td()}>1 行テキスト</td></tr>
        </tbody>
      </table>

      <h3>共有先（CC）情報（4 項目）</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", margin: "12px 0", fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#faf9f7" }}>
            <th style={th()}>ラベル</th>
            <th style={th()}>内部名</th>
            <th style={th()}>タイプ</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={td()}>共有先氏名 1</td><td style={code()}>cs_share_recipient_name</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>共有先メール 1</td><td style={code()}>cs_share_recipient_email</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>共有先氏名 2</td><td style={code()}>cs_share_recipient_name_2</td><td style={td()}>1 行テキスト</td></tr>
          <tr><td style={td()}>共有先メール 2</td><td style={code()}>cs_share_recipient_email_2</td><td style={td()}>1 行テキスト</td></tr>
        </tbody>
      </table>

      <h2>既存プロパティとの衝突</h2>
      <p>
        同じ内部名のプロパティが HubSpot 側に既に存在する場合、衝突せず{" "}
        <strong>スキップ</strong>されます（既存プロパティはそのまま保持）。
        既存プロパティがあれば、当サービスのマッピングはそちらに紐付ければ OK です。
      </p>

      <Callout type="info" title="プロパティグループ">
        作成されるプロパティは HubSpot 側のオブジェクト標準グループ
        （取引: <code>dealinformation</code>、会社: <code>companyinformation</code>、
        コンタクト: <code>contactinformation</code>）に追加されます。
      </Callout>

      <h2>一括作成後にやること</h2>
      <p>
        作成完了後、「接続設定」→「デフォルト設定」で各プロパティの用途を割り当ててください。
        画面下部の「<strong>マッピングを保存</strong>」を押せば設定完了です。
      </p>

      <h2>カスタマイズしたい場合</h2>
      <p>
        HubSpot で既に運用中のプロパティを使いたい場合、一括作成を使わず、
        マッピング画面で既存プロパティを選択してください。
        例：自社で「契約ステータス」というプロパティを既に運用 → そちらにマッピング。
      </p>

      <Callout type="warning" title="プロパティの型に注意">
        マッピング先プロパティの型は以下に合致する必要があります:
        <ul style={{ margin: "6px 0 0 18px" }}>
          <li>ステータス：選択式</li>
          <li>URL 系：1 行テキスト</li>
          <li>書類 ID：1 行テキスト</li>
          <li>宛先・共有先の氏名 / メール：1 行テキスト</li>
          <li>ファイル系（契約書、締結完了ファイル、合意締結証明書）：ファイル型</li>
        </ul>
        型が合わない場合、書き込み時にエラーになります。
      </Callout>
    </>
  );
}

function th() {
  return { textAlign: "left" as const, padding: "8px 12px", borderBottom: "1px solid #d0cfc9" };
}
function td() {
  return { padding: "8px 12px", borderBottom: "1px solid #f0efeb" };
}
function code() {
  return { padding: "8px 12px", borderBottom: "1px solid #f0efeb", fontFamily: "monospace", fontSize: 12, color: "#534AB7" };
}
